import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paperclip, FileText } from 'lucide-react';
import { colors, detailStyles } from './detail.styles';
/**
 * Format file size in bytes to a human-readable string
 */
function formatFileSize(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
export const FileDetail = ({ metadata }) => {
    const fileName = metadata.file_name;
    const fileSize = metadata.file_size;
    const fileType = metadata.file_type || metadata.content_type;
    return (_jsxs("div", { style: detailStyles.detailContent, children: [_jsxs("div", { style: detailStyles.sectionHeader, children: [_jsx(Paperclip, { size: 16, style: { color: colors.accent.purple } }), _jsx("span", { children: "File Details" })] }), _jsxs("div", { children: [fileName && (_jsxs("div", { style: detailStyles.infoRow, children: [_jsx(FileText, { size: 14, style: { color: colors.text.secondary } }), _jsx("span", { style: detailStyles.infoLabel, children: "Name:" }), _jsx("span", { style: detailStyles.infoValue, children: fileName })] })), fileType && (_jsxs("div", { style: detailStyles.infoRow, children: [_jsx("span", { style: detailStyles.infoLabel, children: "Type:" }), _jsx("span", { style: detailStyles.infoValue, children: fileType })] })), fileSize !== undefined && (_jsxs("div", { style: detailStyles.infoRow, children: [_jsx("span", { style: detailStyles.infoLabel, children: "Size:" }), _jsx("span", { style: detailStyles.infoValue, children: formatFileSize(fileSize) })] }))] })] }));
};
export default FileDetail;
